import {
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
  PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT,
  RolodexPermissionsValues,
} from 'types'

export const EDIT_MARKUP_LAYERS_PERMISSIONS_LIST: RolodexPermissionsValues[] = [
  PERMISSION_CANTILEVER_MARKUP_LAYER_EDIT,
  PERMISSION_CANTILEVER_COMPONENT_ARTIFACTS_EDIT,
]
